import { type ColorSwatch } from "@/app/(site)/contexts/Global/types"

export function extractColorSwatchesFromProducts(products: any[]): ColorSwatch[] {
    const colorSwatches: ColorSwatch[] = []
    products.forEach(product => {
        if (product.color_swatch) {
            const swatch: ColorSwatch = {
                color_name: product.color_swatch.color_name,
                hex: product.color_swatch.hex,
                filter_color: product.color_swatch.filter_color,
                isAvailable: product.available,
                sortOrder: Number(product.variant_sort_order_sort_order) || Infinity,
                uri: product.uri,
                image: product?.lens?.image,
                lens: product.lens,
                media: product.media
            }
            colorSwatches.push(swatch)
        }
    })

    return colorSwatches
}
